import { getGardenSlug } from '../../lib/garden';
import FaqEntry from '../../components/feature/FaqEntry';
import { Link } from 'react-router-dom';

export default function Thanks() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50 flex flex-col items-center justify-start px-6 py-12">
      <div className="max-w-lg w-full text-center">
        <div className="bg-white rounded-2xl shadow-xl p-10 md:p-12 border-t-4 border-orange-500">
          <div className="w-20 h-20 flex items-center justify-center bg-green-100 text-green-500 rounded-full mx-auto mb-6">
            <i className="ri-checkbox-circle-fill text-5xl"></i>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            送信完了
          </h1>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            事前確認フォームの送信が完了しました。<br />
            ご協力いただきありがとうございます。
          </p>

          <div className="bg-orange-50 rounded-xl p-6 mb-6 border border-orange-200">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-calendar-check-line text-2xl text-orange-500"></i>
              <h2 className="text-lg font-bold text-gray-800">当日お待ちしております</h2>
            </div>
            <p className="text-base text-gray-700">
              ご不明な点がございましたら、<br />
              <a href="mailto:info@kirari-hoiku.com" className="text-orange-600 font-medium hover:underline">
                info@kirari-hoiku.com
              </a><br />
              までお気軽にご連絡ください。
            </p>
          </div>

          {/* 遅刻連絡に関する注意書き */}
          <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6 mb-8 border-2 border-amber-400">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500 text-white rounded-full flex-shrink-0">
                <i className="ri-alarm-warning-line text-xl"></i>
              </div>
              <div className="text-left">
                <h3 className="text-lg font-bold text-amber-800 mb-2">
                  出勤時間について重要なお願い
                </h3>
                <p className="text-sm text-gray-800 leading-relaxed mb-3">
                  <strong className="text-amber-700">出勤時間直前の遅刻連絡が多く発生しております。</strong>朝の時間帯は園としても最も多忙な時間帯であり、電話対応が困難な状況です。
                </p>
                <div className="bg-white rounded-lg p-4 border border-amber-200">
                  <p className="text-sm text-gray-800 leading-relaxed">
                    <i className="ri-time-line text-amber-600 mr-2"></i>
                    社会人として、<strong className="text-amber-700">余裕を持って現地に到着</strong>いただきますようお願いいたします。交通機関の遅延等も考慮し、早めの行動を心がけてください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 送ったあとが、いちばん聞きたいことが出てくるとき。質問ボタンを並べて、押すとそのままあおいが答える */}
        <ThanksAsk />

        <div className="mt-8">
          <a
            href="https://kirari-hoiku.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img
              src="/images/gaikan.jpeg"
              alt="きらり保育園箕面"
              className="h-16 w-auto object-contain mx-auto"
            />
          </a>
        </div>
      </div>

      {/* タイミーワーカー様への特別オファーセクション */}
      <div className="max-w-2xl w-full mt-12">
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl shadow-xl p-4 md:p-10 border-2 border-teal-300">
          {/* ヘッダー */}
          <div className="text-center mb-5 md:mb-8">
            <div className="inline-flex items-center gap-1.5 md:gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-xs md:text-sm font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-full shadow-lg mb-3 md:mb-4">
              <i className="ri-vip-crown-line text-base md:text-lg"></i>
              認定ワーカー限定
            </div>
            <h3 className="text-xl md:text-4xl font-bold text-gray-800 mb-2 md:mb-3">
              タイミーワーカー様への<br />特別オファー
            </h3>
            <p className="text-base md:text-xl font-bold text-teal-700">
              直接雇用（スポット）切り替えのご案内
            </p>
          </div>

          {/* 5回リミットの説明 */}
          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-xl md:rounded-2xl p-4 md:p-6 mb-4 md:mb-6">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-amber-500 text-white rounded-full flex-shrink-0">
                <i className="ri-information-line text-xl md:text-2xl"></i>
              </div>
              <div>
                <h4 className="text-base md:text-xl font-bold text-amber-800 mb-2">
                  きらりでは、タイミー経由は5回までのリミットがあります
                </h4>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed mb-3">
                  なぜ5回までなのか？その理由をお伝えします。
                </p>
              </div>
            </div>
            
            <div className="bg-white rounded-lg md:rounded-xl p-3 md:p-5 space-y-3">
              <div className="flex items-start gap-2 md:gap-3">
                <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center bg-teal-100 text-teal-600 rounded-full flex-shrink-0 font-bold text-xs md:text-sm">
                  １
                </div>
                <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                  <strong className="text-teal-600">きらりの一員になってほしい</strong><br />
                  タイミーからの「お客様」ではなく、きらりファミリーの仲間として一緒に働いてほしいと考えています。
                </p>
              </div>
              
              <div className="flex items-start gap-2 md:gap-3">
                <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center bg-purple-100 text-purple-600 rounded-full flex-shrink-0 font-bold text-xs md:text-sm">
                  ２
                </div>
                <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                  <strong className="text-purple-600">長期的な関係を築きたい</strong><br />
                  5回の勤務で<strong>お互いの相性</strong>を確認し、認定ワーカーとして直接雇用に切り替えることで、より良い関係を築けます。
                </p>
              </div>
            </div>
            
            <div className="mt-4 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-lg md:rounded-xl p-3 md:p-4 text-center">
              <p className="text-sm md:text-base font-bold">
                だから、5回目までに<span className="text-yellow-300">「認定ワーカー」</span>として<br className="md:hidden" />直接雇用への切り替えをご提案しています
              </p>
            </div>
          </div>

          {/* メインメッセージ */}
          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-lg mb-4 md:mb-6">
            <div className="flex items-start gap-2 md:gap-3 mb-3 md:mb-4">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-teal-500 text-white rounded-full flex-shrink-0">
                <i className="ri-heart-3-fill text-lg md:text-xl"></i>
              </div>
              <div>
                <p className="text-sm md:text-lg text-gray-800 leading-relaxed">
                  タイミーからの「お客様」ではなく、きらりの一員として一緒に働きませんか？
                </p>
              </div>
            </div>
          </div>

          {/* 提案 */}
          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-lg mb-4 md:mb-6">
            <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-4">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 text-white rounded-full">
                <i className="ri-lightbulb-flash-line text-xl md:text-2xl"></i>
              </div>
              <h4 className="text-lg md:text-2xl font-bold text-gray-800">そこで、ご提案です</h4>
            </div>
            <p className="text-sm md:text-lg text-gray-800 leading-relaxed">
              当園独自のスポットワークシステムへ直接登録いただけないでしょうか？
            </p>
          </div>

          {/* 3つのメリット */}
          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-lg mb-4 md:mb-6">
            <h4 className="text-lg md:text-2xl font-bold text-gray-800 mb-4 md:mb-6 text-center flex items-center justify-center gap-2">
              <i className="ri-gift-line text-teal-500 text-2xl md:text-3xl"></i>
              切り替える3つのメリット
            </h4>
            
            <div className="space-y-3 md:space-y-4">
              {/* メリット1 */}
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-xl p-3 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 md:w-12 md:h-12 flex items-center justify-center bg-green-500 text-white rounded-full font-bold text-base md:text-xl flex-shrink-0">
                    1
                  </div>
                  <div className="flex-1 min-w-0">
                    <h5 className="text-base md:text-xl font-bold text-green-800 mb-1 md:mb-2 flex items-center gap-1 md:gap-2">
                      <i className="ri-money-dollar-circle-line hidden md:inline"></i>
                      安定した収入
                    </h5>
                    <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                      <strong className="text-green-600">時給1,300円保証</strong>。仕事内容は変わりません。
                    </p>
                  </div>
                </div>
              </div>

              {/* メリット2 */}
              <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-300 rounded-xl p-3 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 md:w-12 md:h-12 flex items-center justify-center bg-blue-500 text-white rounded-full font-bold text-base md:text-xl flex-shrink-0">
                    2
                  </div>
                  <div className="flex-1 min-w-0">
                    <h5 className="text-base md:text-xl font-bold text-blue-800 mb-1 md:mb-2 flex items-center gap-1 md:gap-2">
                      <i className="ri-calendar-check-line hidden md:inline"></i>
                      あなたに優先的にお仕事枠を
                    </h5>
                    <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                      あなたが出られる日をいただき優先的にシフトを組みます。予定がかかなか、見えない場合は空いている日に<strong className="text-blue-600">ポチッと応募</strong>するだけ。
                    </p>
                  </div>
                </div>
              </div>

              {/* メリット3 */}
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-300 rounded-xl p-3 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 md:w-12 md:h-12 flex items-center justify-center bg-purple-500 text-white rounded-full font-bold text-base md:text-xl flex-shrink-0">
                    3
                  </div>
                  <div className="flex-1 min-w-0">
                    <h5 className="text-base md:text-xl font-bold text-purple-800 mb-1 md:mb-2 flex items-center gap-1 md:gap-2">
                      <i className="ri-vip-crown-line hidden md:inline"></i>
                      きらりファミリーの一員
                    </h5>
                    <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                      <strong className="text-purple-600">認定ワーカー</strong>として、特別な存在になれます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 登録・利用の流れ */}
          <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-lg mb-4 md:mb-6">
            <h4 className="text-lg md:text-2xl font-bold text-gray-800 mb-3 md:mb-4 text-center flex items-center justify-center gap-2">
              <i className="ri-route-line text-teal-500 text-2xl md:text-3xl"></i>
              登録・利用の流れ
            </h4>
            <p className="text-sm md:text-lg text-center text-gray-700 mb-4 md:mb-6">
              <strong className="text-teal-600">面接なし。</strong>登録するだけで完了！
            </p>
            
            <div className="flex items-center justify-between md:justify-center md:gap-8">
              <div className="flex flex-col items-center text-center">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-teal-100 text-teal-600 rounded-full font-bold text-sm md:text-base mb-1 md:mb-2">
                  1
                </div>
                <p className="text-xs md:text-base font-bold text-gray-800">登録</p>
                <p className="text-[10px] md:text-sm text-gray-600 hidden md:block">フォームから登録</p>
              </div>
              <i className="ri-arrow-right-line text-teal-400 text-lg md:text-2xl"></i>
              <div className="flex flex-col items-center text-center">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-teal-100 text-teal-600 rounded-full font-bold text-sm md:text-base mb-1 md:mb-2">
                  2
                </div>
                <p className="text-xs md:text-base font-bold text-gray-800">通知</p>
                <p className="text-[10px] md:text-sm text-gray-600 hidden md:block">メールが届く</p>
              </div>
              <i className="ri-arrow-right-line text-teal-400 text-lg md:text-2xl"></i>
              <div className="flex flex-col items-center text-center">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-teal-100 text-teal-600 rounded-full font-bold text-sm md:text-base mb-1 md:mb-2">
                  3
                </div>
                <p className="text-xs md:text-base font-bold text-gray-800">勤務</p>
                <p className="text-[10px] md:text-sm text-gray-600 hidden md:block">スポットで勤務</p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-xl md:rounded-2xl p-5 md:p-8 text-center shadow-xl">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-4">
              <i className="ri-star-smile-fill text-2xl md:text-4xl text-yellow-300"></i>
            </div>
            <p className="text-base md:text-xl text-white font-bold mb-3 md:mb-4 leading-relaxed">
              勤務後、あなたの評価に応じて<br />
              オファーをお送りします
            </p>
            <div className="bg-white/20 rounded-lg md:rounded-xl p-3 md:p-5 mb-3 md:mb-4">
              <p className="text-white text-xs md:text-base leading-relaxed">
                <strong className="text-yellow-300">「顧客目線」</strong>と<strong className="text-yellow-300">「笑顔」</strong>を評価し、<br className="md:hidden" />
                基準を満たした方に<strong className="text-yellow-300">認定ワーカー</strong>として特別オファーをお送りします。
              </p>
            </div>
            <p className="text-white text-xs md:text-sm opacity-90">
              <i className="ri-information-line mr-1"></i>
              まずは本日の勤務で、あなたの力を見せてください。
            </p>
          </div>

          {/* フッターメッセージ */}
          <div className="mt-4 md:mt-6 text-center">
            <p className="text-sm md:text-base text-gray-700">
              <i className="ri-mail-line text-teal-500 mr-2"></i>
              ご登録をお待ちしております。
            </p>
          </div>
        </div>
      </div>

      {/* きらりクリーン リンク & トップページに戻るボタン - 最下部 */}
      <div className="max-w-lg w-full mt-12">
        {/* きらりクリーン リンク */}
        <a
          href="https://kirari-clean.jp/"
          target="_blank"
          rel="noopener noreferrer"
          className="block mb-8 group cursor-pointer"
        >
          <div className="bg-gradient-to-r from-sky-50 to-teal-50 rounded-xl border border-sky-200 overflow-hidden shadow-md hover:shadow-lg transition-all duration-200">
            {/* 見出し */}
            <div className="p-4 pb-2">
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="w-6 h-6 flex items-center justify-center bg-teal-500 text-white rounded-full">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-lg font-bold text-teal-700">きらり保育園から無添加洗浄剤が生まれました。</span>
              </div>
            </div>
            {/* サムネイル画像 */}
            <div className="w-full h-48 overflow-hidden">
              <img
                src="/images/thanks_img.jpeg"
                alt="きらりクリーン"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4 bg-gradient-to-r from-sky-50 to-teal-50">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-external-link-line text-sky-500"></i>
                <span className="text-sm font-bold text-sky-600">きらりクリーン</span>
              </div>
              <p className="text-xs text-gray-600">子どもの未来を想う「きらり保育園」から生まれた除菌洗浄剤</p>
            </div>
          </div>
        </a>

        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold py-4 px-8 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-200 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap w-full"
        >
          <i className="ri-arrow-left-line"></i>
          トップページに戻る
        </Link>
      </div>
    </div>
  );
}

function ThanksAsk() {
  return (
    <div className="mt-8 bg-white border-2 border-gray-200 rounded-2xl p-4 shadow-sm text-left">
      <FaqEntry garden={getGardenSlug()} />
    </div>
  );
}
